module.exports = __webpack_public_path__ + "img/op_five_steps_4.c02d6c77.png";